module.exports = __webpack_public_path__ + "static/media/089-sint-maarten.202ca1c0.svg";